export default function DSA_Ford_Fulkerson() {
  return <div>DSA_Ford_Fulkerson Component</div>;
}
